<template>
    <Navbar/>
    <!-- Hero Area -->
    <div class="hero-area banner-2 light-bg-1" id="home">                   
        <div class="hero-area-inner">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 wow fadeInUp animated hero-name-layer" data-wow-delay=".2s">
                        <div class="section-title">
                            <h1 class="text-dark hero-text-above">{{intro.name}}</h1>                                
                        </div>                            
                    </div>  
                    <div class="col-lg-5">
                        <div class="hero-author-img">
                            <img :src="intro.image" alt="">
                        </div>
                        <div class="banner-author-bg">
                            <img src="/assets/img/banner-author-bg.png" alt="">
                        </div>
                    </div>                      
                </div>
            </div>                
        </div>            
    </div>

    <!-- About Section -->
    <div id="about" class="about-section about-two section-padding gray-bg-2">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-12 wow fadeInUp animated" data-wow-delay="100ms">
                    <div class="about-left">
                        <div class="repeat-grid">
                            <img :src="about.image" alt="">
                        </div>
                        <div class="section-title">
                            <h6 class="text-gray-2">About gharb <span>.....</span> </h6>
                        </div>
                        <p class="text-gray">{{about.description}} </p>
                        <p class="text-gray">open 11:00-21:00 <br> closed sundays</p>                        
                        <p class="text-gray">{{about.address}}</p>                        
                        <p class="text-gray">{{about.contact}}</p>                        
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-12 wow fadeInDown animated" data-wow-delay="200ms">
                    <div class="about-right">
                        <div class="map-wrap">
                            <!-- Google Maps iframe - fancybox除外設定を追加 -->
                            <iframe 
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.915554066749!2d139.65190415034127!3d35.654452138951456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f38ef98ded8b%3A0x79dfa5b76e225e49!2z44Kr44OV44Kn44Ks44Or44OW!5e0!3m2!1sja!2sjp!4v1681302011801!5m2!1sja!2sjp" 
                                width="600" 
                                height="450" 
                                style="border:0;" 
                                allowfullscreen="" 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade"
                                class="google-map-iframe"
                                data-fancybox-exclude="true"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
        <div class="about-dot-shape">
            <img src="/assets/img/about-dot-shape.png" alt="">
        </div>
    </div>

    <!-- Service Section  -->
    <div id="services" class="service-section service-two section-padding pt-0">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <div class="section-title">
                        <h6 class="text-gray-2">Menu <span>.....</span> </h6>
                        <h2 class="text-dark">What We Offer</h2>                            
                    </div>
                </div>
            </div>
            <div class="row gx-5">
                <div class="col-xl-4 col-lg-4 col-md-6 col-12 wow fadeInLeft animated" :data-wow-delay="(i+1)*100+'ms'" v-for="(service,i) in services" :key="service.id">
                    <div class="single-service-item">
                        <div class="service-inner">
                            <div class="service-icon">
                                <img :src="service.icon" alt="">
                            </div>
                            <div class="service-content">
                                <h4>{{service.name}}</h4>
                                <p v-html="service.description.split('\n').join('<br>')"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Portfolio Section  -->
    <div id="project" class="portfolio-section portfolio-two section-padding gray-bg">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <div class="section-title">
                        <h6 class="text-gray-2">Instagharb <span>.....</span> </h6>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="portfolio-list recent">
                        <div :class="'portfolio-bg-wrap '+portfolio.categories" v-for="portfolio in portfolios" :key="portfolio.id" :style="'background-image:url('+portfolio.background_image+')'">
                            <div class="portfolio-details">
                                <h4 class="portfolio-title"><a href="#">{{portfolio.name}}</a></h4>
                                <p>{{portfolio.type}}</p>
                            </div>							
                        </div>                         
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Blog Section - Googleスプレッドシート連携版 -->
    <div id="blog" class="blog-section section-padding dark-bg-1">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <div class="section-title">
                        <h6>News <span>.....</span> </h6>
                        <h4>gharbからのお知らせ</h4>         
                    </div>
                </div>
            </div>
            
            <!-- ローディング表示 -->
            <div v-if="newsLoading" class="row">
                <div class="col-12 text-center">
                    <p class="text-white">ニュースを読み込んでいます...</p>
                </div>
            </div>
            
            <!-- Googleスプレッドシートからのニュース表示 -->
            <div v-else-if="googleNewsItems.length > 0" class="row">
                <div 
                    class="col-xl-4 col-lg-4 col-md-6 col-12 wow fadeInLeft animated" 
                    :data-wow-delay="(i+1)*100+'ms'" 
                    v-for="(news, i) in googleNewsItems.slice(0,3)" 
                    :key="news.id"
                >
                    <div class="single-blog-item">
                        <div class="blog-thumb">
                            <!-- メイン画像を表示 -->
                            <img 
                                :src="getMainImage(news)" 
                                :alt="news.title"
                                @error="handleImageError"
                            >
                        </div>
                        <div class="blog-content">
                            <div class="blog-meta">
                                <p>{{ formatDate(news.date) }}</p>
                            </div>
                            <div class="blog-title">
                                <h4><router-link :to="`/news/${news.id}`">{{ news.title }}</router-link></h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>      
            <!-- フォールバック：既存のJSONデータ表示 -->
            <div v-else class="row">
                <div 
                    class="col-xl-4 col-lg-4 col-md-6 col-12 wow fadeInLeft animated" 
                    :data-wow-delay="(i+1)*100+'ms'" 
                    v-for="(blog,i) in blogs.slice(0,3)" 
                    :key="blog.id"
                >
                    <div class="single-blog-item">
                        <div class="blog-thumb">
                            <img :src="blog.image" alt="">
                        </div>
                        <div class="blog-content">
                            <div class="blog-meta">
                                <p>{{blog.date}}</p>
                            </div>
                            <div class="blog-title">
                                <h4><router-link :to="{ name:'BlogDetails', params:{id: blog.id} }">{{blog.title}}</router-link></h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Footer/>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import ClientReviews from '@/components/ClientReviews.vue'
import axios from 'axios'

export default {
    name: 'Home',
    components: {
        Navbar, Footer, ClientReviews
    },
    data() {
        return {
            // 既存のデータ
            services: [],
            educations: [],
            skills: [],
            experiences: [],
            portfolios: [],
            about: [],
            blogs: [],
            intro: [],
            home: '',
            
            // Googleスプレッドシート用の新しいデータ
            googleNewsItems: [],
            newsLoading: true,
            
            // GoogleスプレッドシートのID（環境変数から取得）
            SHEET_ID: process.env.VUE_APP_GOOGLE_SHEET_ID || ''
        }
    },
    computed: {
        // デバッグ用：環境変数の状態確認
        sheetIdStatus() {
            return this.SHEET_ID ? '設定済み' : '未設定';
        }
    },
    async mounted() {
        // 既存の初期化処理
        
        // setting active home as Home to local storage
        localStorage.setItem("home", "Home");
        
        // setting active home as Home to vue-store
        this.$store.commit("setHome", "Home");
        
        // getting active home from vue-store
        this.home = this.$store.state.home;
        
        // Isotope Filter
        $(".port-menu li").on("click", function () {
            var selector = $(this).attr("data-filter");
            
            $(".port-menu li").removeClass("active");
            $(this).addClass("active");
            
            $(".portfolio-list").isotope({
                filter: selector,
                percentPosition: true,
            });
        });
        
        // 既存のデータ取得
        let fetchedData = await axios.get("/assets/data/services.json");
        this.services = fetchedData.data.services;
        
        let fetchedEducationData = await axios.get("/assets/data/educations.json");
        this.educations = fetchedEducationData.data.educations;
        
        let fetchedSkillData = await axios.get("/assets/data/skills.json");
        this.skills = fetchedSkillData.data.skills;
        
        let fetchedExperienceData = await axios.get("/assets/data/experiences.json");
        this.experiences = fetchedExperienceData.data.experiences;
        
        let fetchedPortfolioData = await axios.get("/assets/data/portfolios.json");
        this.portfolios = fetchedPortfolioData.data.portfolios;
        
        let fetchedAboutData = await axios.get("/assets/data/about.json");
        this.about = fetchedAboutData.data.about;
        
        let fetchedBlogsData = await axios.get("/assets/data/blogs.json");
        this.blogs = fetchedBlogsData.data.blogs;
        
        let fetchedIntroData = await axios.get("/assets/data/home.json");
        this.intro = fetchedIntroData.data.intro;
        
        // Googleスプレッドシートからニュースを取得
        await this.fetchGoogleSheetNews();
        
        // デバッグ: 環境変数が正しく読み込まれているか確認（開発環境のみ）
        if (process.env.NODE_ENV === 'development') {
            console.log('Google Sheet ID:', this.SHEET_ID ? '設定済み' : '未設定');
        }
    },
    methods: {
        // Googleスプレッドシートからニュースを取得
        async fetchGoogleSheetNews() {
            try {
                this.newsLoading = true;
                
                if (!this.SHEET_ID) {
                    console.log('Google Sheet IDが設定されていません');
                    this.googleNewsItems = [];
                    return;
                }
                
                // CSV形式でエクスポート（キャッシュ回避のためタイムスタンプを追加）
                const CSV_URL = `https://docs.google.com/spreadsheets/d/${this.SHEET_ID}/export?format=csv&gid=0&t=${Date.now()}`;
                
                // 直接取得を試みる
                try {
                    const response = await fetch(CSV_URL);
                    const csvText = await response.text();
                    this.googleNewsItems = this.parseCSV(csvText);
                    console.log('Parsed news items:', this.googleNewsItems);
                } catch (corsError) {
                    // CORSエラーの場合はプロキシ経由
                    console.log('CORS回避のためプロキシを使用');
                    await this.fetchWithProxy();
                }
                
            } catch (error) {
                console.error('Googleスプレッドシート取得エラー:', error);
                // エラー時は既存のブログデータを使用
                this.googleNewsItems = [];
            } finally {
                this.newsLoading = false;
            }
        },
        
        // CORSプロキシ経由で取得
        async fetchWithProxy() {
            try {
                // キャッシュ回避のためタイムスタンプを追加
                const CSV_URL = `https://docs.google.com/spreadsheets/d/${this.SHEET_ID}/export?format=csv&gid=0&t=${Date.now()}`;
                const proxyUrl = `https://api.allorigins.win/get?url=${encodeURIComponent(CSV_URL)}`;
                
                const response = await fetch(proxyUrl);
                const data = await response.json();
                this.googleNewsItems = this.parseCSV(data.contents);
                
            } catch (error) {
                console.error('プロキシ経由の取得もエラー:', error);
            }
        },
        
        // CSV解析（改行を含むフィールドに対応）
        parseCSV(csvText) {
            const rows = this.parseCSVToRows(csvText);
            
            if (rows.length < 2) return [];
            
            const headers = rows[0].map(h => h.toLowerCase().trim());
            const newsItems = [];
            
            for (let i = 1; i < rows.length; i++) {
                const values = rows[i];
                const item = {};
                
                headers.forEach((header, index) => {
                    item[header] = values[index] || '';
                });
                
                // idとtitleが存在するか確認
                if (!item.id || !item.title) {
                    continue;
                }
                
                // published判定を改善（大文字・小文字・日本語対応）
                const publishedValue = (item.published || '').toString().toUpperCase().trim();
                if (publishedValue === 'TRUE' || publishedValue === '公開' || publishedValue === 'YES' || publishedValue === '1') {
                    newsItems.push(item);
                }
            }
            
            // 日付順にソート（新しい順）
            return newsItems.sort((a, b) => new Date(b.date) - new Date(a.date));
        },
        
        // CSVテキストを行の配列に変換（改行を含むフィールドに対応）
        parseCSVToRows(csvText) {
            const rows = [];
            let currentRow = [];
            let currentField = '';
            let inQuotes = false;
            
            for (let i = 0; i < csvText.length; i++) {
                const char = csvText[i];
                const nextChar = csvText[i + 1];
                
                if (inQuotes) {
                    if (char === '"') {
                        if (nextChar === '"') {
                            // エスケープされたダブルクォート
                            currentField += '"';
                            i++; // 次の文字をスキップ
                        } else {
                            // クォート終了
                            inQuotes = false;
                        }
                    } else {
                        // クォート内の文字（改行含む）
                        currentField += char;
                    }
                } else {
                    if (char === '"') {
                        // クォート開始
                        inQuotes = true;
                    } else if (char === ',') {
                        // フィールド区切り
                        currentRow.push(currentField.trim());
                        currentField = '';
                    } else if (char === '\n' || (char === '\r' && nextChar === '\n')) {
                        // 行終了
                        currentRow.push(currentField.trim());
                        if (currentRow.some(field => field !== '')) {
                            rows.push(currentRow);
                        }
                        currentRow = [];
                        currentField = '';
                        if (char === '\r') {
                            i++; // \nをスキップ
                        }
                    } else if (char === '\r') {
                        // 単独の\r（古いMac形式）
                        currentRow.push(currentField.trim());
                        if (currentRow.some(field => field !== '')) {
                            rows.push(currentRow);
                        }
                        currentRow = [];
                        currentField = '';
                    } else {
                        currentField += char;
                    }
                }
            }
            
            // 最後のフィールドと行を追加
            if (currentField || currentRow.length > 0) {
                currentRow.push(currentField.trim());
                if (currentRow.some(field => field !== '')) {
                    rows.push(currentRow);
                }
            }
            
            return rows;
        },
        
        // メイン画像を取得
        getMainImage(news) {
            // image1 または imageUrl を使用
            if (news.image1 && news.image1.trim()) {
                return news.image1;
            }
            if (news.imageurl && news.imageurl.trim()) {
                return news.imageurl;
            }
            // デフォルト画像
            return 'https://www.gharb.tokyo/assets/img/blog/news1.png';
        },
        
        // 画像エラー時のハンドリング
        handleImageError(event) {
            event.target.src = 'https://www.gharb.tokyo/assets/img/blog/news1.png';
        },
        
        // 日付フォーマット
        formatDate(date) {
            if (!date) return '';
            try {
                return new Date(date).toLocaleDateString('ja-JP', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            } catch (e) {
                return date;
            }
        }
    }
}
</script>

<style scoped>
/* Google Maps iframe用のスタイル */
.map-wrap {
    position: relative;
    width: 100%;
    height: 450px;
    overflow: hidden;
    border-radius: 10px;
}

.map-wrap iframe.google-map-iframe {
    width: 100%;
    height: 100%;
    border: 0;
}
</style>